export default "__VITE_ASSET__BA0o7qWZ__"